import type { KeyboardEvent, ReactNode } from 'react';

import styles from './ToggleButton.module.css';

import { Minus, Plus } from '../../icons';
import { ButtonBase } from '../ButtonBase';
import { Ellipsis } from '../Ellipsis';

interface ToggleButtonProps {
  id: string | undefined;
  sectionId: string | undefined;
  open: boolean;
  onClick: () => void;
  onKeyDown?: (e: KeyboardEvent<HTMLButtonElement>) => void;
  children?: ReactNode;
}

export function ToggleButton({
  id,
  sectionId,
  open,
  onClick,
  onKeyDown,
  children,
}: ToggleButtonProps) {
  return (
    <ButtonBase
      type="button"
      onClick={onClick}
      onKeyDown={onKeyDown}
      className={styles.button}
      aria-controls={sectionId}
      aria-expanded={open}
      id={id}
    >
      <Ellipsis>{children}</Ellipsis>
      <>
        {open ? (
          <Minus aria-label="Close" baseColor="Kale3" height={36} />
        ) : (
          <Plus aria-label="Open" baseColor="Kale3" height={36} />
        )}
      </>
    </ButtonBase>
  );
}
